import { useState, useEffect } from "react";
import React from "react";
import { toast } from 'react-toastify';
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from '../shared/components/Header'
import Pagination from '@mui/material/Pagination';
import moment from 'moment';
import { API_FACTURAS } from "../shared/services/facturas";
import { useDispatch, useSelector } from "react-redux";
import { fetchDevoluciones } from "../../../../redux/devoluciones";
import ActionsMenu from "../shared/components/ActionsMenu";
import { getActions } from "./actions";

export default function Devoluciones() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { page } = useParams();
  const currPage = parseInt(page);
  const [currentPage, setPage] = useState(currPage);
  const tiposDevolucion = useSelector(state => {
    const { tipo_devoluciones } = state;
    return tipo_devoluciones;
  });
  const devoluciones = useSelector(state => state.devoluciones);
  const searcher = useSelector(state => state.search)

  useEffect(() => {
    dispatch(fetchDevoluciones(currPage, getQuery()));
  }, [searcher]);

  const getQuery = () => {
    const isEmpty = Object.values(searcher).every(x => x === null || x === '');
    const query = !isEmpty ? 'search=' + (searcher?.search ? searcher?.search : '') 
      + (searcher?.start_date ? '&start_date=' + searcher?.start_date : '')
      + (searcher?.end_date ? '&end_date=' + searcher?.end_date : '')
      + (searcher?.min ? '&min=' + searcher?.min : '')
      + (searcher?.max ? '&max=' + searcher?.max : '')
      + (searcher?.responsable ? '&responsable=' + searcher?.responsable : '')
    : null;

    return query;
  }

  const handleSearch = (search, searchData) => {
    setPage(1);
    navigate(`/devoluciones/${1}`);
    dispatch({type: "search/set", payload: searchData});     
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    navigate(`/devoluciones/${newPage}`);
    dispatch(fetchDevoluciones(newPage, getQuery()));
  }

  const getPaginationCount = () => {
    var totalPages = devoluciones?.total_items < 15 ? 1 : Math.ceil(devoluciones?.total_items / 15);
    return totalPages ? parseInt(totalPages) : 0;
  }

  const handleAction = (action, devolucion) => {
    if(action === 'download') {
      generateThePdf(devolucion)
    } else  if(action === '') {
      
    } 
  }

  const getTipoDevolucionName = (tipoId) => tiposDevolucion.find(td => td.id === tipoId)?.nombre;

  const handleViewVentas = () => { 
    dispatch({type: "search/set", payload: ""});
    navigate('/ventas/1');
  }

  const generateThePdf = async (devolucion) => {
    dispatch({type: 'loading/set', payload: true});
    const pdfResult = await API_FACTURAS.generateFacturaPDF(devolucion.factura_id);

    if(pdfResult) {
      window.open(pdfResult.data, "_blank");
    } else {
      toast.error('Ups! Algo ha ido mal...')
    }
    dispatch({type: 'loading/set', payload: false});
  }

  return (
    <div className="content pt-3">
      <div className="w-100 d-flex flex-wrap align-items-end justify-content-between">
        <Header viewSearch={true} onSearch={handleSearch}></Header>
        <button className="btn btn-default" onClick={handleViewVentas}>Ventas</button>
      </div>

      <div className="w-100 d-flex flex-column align-items-end content-table">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>dev</th>
                <th>tipo</th>
                <th className="text-center">venta</th>
                <th className="text-center">fecha</th>
                <th className="text-center">factura</th>
                <th>cliente</th>
                <th>telf</th>
                <th>Pieza</th>
                <th className="text-center">€ venta</th>
                <th className="text-center">€ dev</th>
                <th className="text-center">€ envio</th>
                <th className="text-center">total</th>
                <th className="text-center">envio</th>
                <th className="text-center">descuento</th>
                <th className="text-center">total IVA</th>
                <th className="text-center">resp</th>
                <th className="text-center">creado por</th>
                <th className="text-center"></th>
              </tr>
            </thead>

            { devoluciones.devoluciones?.map((devolucion, index) => {
                const piezasValues = Object.values(devolucion.piezas)
                const piezasRows = piezasValues.map((pieza, i) => {
                  const dev = i === 0 ? <td rowSpan={piezasValues.length + 1} width="3%">{devolucion.id}</td> : null
                  const tipo = i === 0 ? <td rowSpan={piezasValues.length + 1} width="3%" className="text-uppercase">{getTipoDevolucionName(devolucion.tipo_devolucion_id)}</td> : null
                  const venta = i === 0 ? <td rowSpan={piezasValues.length + 1} width="3%" className="text-center">{devolucion.venta_id}</td> : null
                  const fecha = i === 0 ?  <td rowSpan={piezasValues.length + 1} width="6%" className="text-center">{moment(devolucion.fecha).format("DD-MM-YYYY")}</td> : null
                  const factura = i === 0 ?  <td rowSpan={piezasValues.length + 1} width="6%" className="text-center">{
                    devolucion.numero
                  }</td> : null
                  const cliente = i === 0 ?  <td rowSpan={piezasValues.length + 1} width="12%">
                    <Link target="_blank" rel="noopener noreferrer" to={`/cliente/${devolucion.cliente?.id}`} title="Ficha Cliente" className="text-green text-uppercase">
                      {devolucion.cliente?.nombre}
                    </Link>
                  </td> : null
                  const clienteTelf = i === 0 ?  <td rowSpan={piezasValues.length + 1}>{devolucion.cliente.telefono}</td> : null
                  const total = i === 0 ? <td rowSpan={piezasValues.length + 1} className="text-center">{parseFloat(devolucion.total).toFixed(2)}</td> : null
                  const envio = i === 0 ? <td rowSpan={piezasValues.length + 1} className="text-center">{parseFloat(devolucion.total_envio).toFixed(2)}</td> : null
                  const descuento = i === 0 ? <td rowSpan={piezasValues.length + 1} className="text-center">
                    { (devolucion?.vale_descuento || devolucion?.codigo_descuento_masivo) ? 
                      <div className="d-flex flex-column">
                        +{parseFloat(devolucion.total_descuento_iva > 0 ? devolucion.total_descuento_iva : devolucion.total_descuento).toFixed(2)}€
                        <span className="fw-bold text-green">{(devolucion?.vale_descuento?.codigo || devolucion?.codigo_descuento_masivo)}</span>
                      </div>
                      : '-'
                    }
                  </td> : null
                  const totalIva = i === 0 ? <td rowSpan={piezasValues.length + 1} className="text-center">{parseFloat(devolucion.total_iva).toFixed(2)}</td> : null
                  const responsable = i === 0 ?  <td rowSpan={piezasValues.length + 1}  className="text-center text-uppercase">{devolucion.created_by?.username}</td> : null
                  const createdBy = i === 0 ?  <td rowSpan={piezasValues.length + 1}  className="text-center text-uppercase">{devolucion.crafted_by?.username}</td> : null
                  const acciones = i === 0 ?  <td rowSpan={piezasValues.length + 1} className="text-center">
                    <ActionsMenu 
                        options={getActions()}
                        onAction={(action) => handleAction(action, devolucion)}
                    />
                  </td> : null
                      
                  return (
                    <tr key={i}>
                      {dev}
                      {tipo}
                      {venta}
                      {fecha}
                      {factura}
                      {cliente}
                      {clienteTelf}
                      <td>
                        { pieza?.devolucion_relationship?.unidades > 1 ? 
                          <strong>{'x'+pieza?.devolucion_relationship?.unidades}</strong> : '' 
                        } 
                        {pieza.nombre.length > 25 ? pieza.nombre.substring(0, 25) + '...' : pieza.nombre}
                      </td>
                      <td className="text-center">{parseFloat(pieza.precio_venta).toFixed(2)}€</td>
                      <td className="text-center">{parseFloat(pieza.devolucion_relationship.importe).toFixed(2)}€</td>
                      <td className="text-center">{parseFloat(pieza.devolucion_relationship.importe_envio).toFixed(2)}€</td>
                      {total}
                      {envio}
                      {descuento}
                      {totalIva}
                      {responsable}
                      {createdBy}
                      {acciones}
                    </tr>
                  )
                })
                return (
                  <tbody key={index}>
                    {piezasRows}
                  </tbody>
                )
              }) 
            }
          </table>
        </div>

        <Pagination 
          className="mt-3" 
          count={getPaginationCount()} 
          page={currentPage} 
          onChange={handleChangePage} 
        />
      </div>
    </div>
  )
}